import { EventStaticFieldIds } from '@tribeplatform/react-components/Event'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { StaticField } from '@tribeplatform/react-components/Views'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const staticFieldsFactory: (intl: I18nShape) => StaticField[] = ({
  $t,
}) => [
  {
    id: EventStaticFieldIds.CoverImage,
    label: $t({
      defaultMessage: 'Cover image',
      id: 'EventsListBlock.Settings.Properties.CoverImage',
    }),
    enabled: true,
    locked: true,
    settings: {},
    isStatic: true,
    icon: <SvgIcon name="image" />,
  },
  {
    id: EventStaticFieldIds.EventDetails,
    label: $t({
      defaultMessage: 'Event details',
      id: 'EventsListBlock.Settings.Properties.EventDetails',
    }),
    enabled: true,
    locked: true,
    settings: {},
    isStatic: true,
    icon: <SvgIcon name="calendar" />,
  },
  {
    id: EventStaticFieldIds.HostInfo,
    label: $t({
      defaultMessage: 'Host info',
      id: 'EventsListBlock.Settings.Properties.HostInfo',
    }),
    enabled: true,
    locked: true,
    settings: {},
    isStatic: true,
    icon: <SvgIcon name="user" />,
  },
  {
    id: EventStaticFieldIds.Attendees,
    label: $t({
      defaultMessage: 'Attendees',
      id: 'EventsListBlock.Settings.Properties.Attendees',
    }),
    enabled: true,
    locked: true,
    settings: {},
    isStatic: true,
    icon: <SvgIcon name="check-circle" />,
  },
]
